module.exports = [roleCodeTypeaheadFilter];

function roleCodeTypeaheadFilter() {

    return function (roles, query) {
        var result;
        if (query === null || query === undefined || query === '') {
            result = _.sortBy(roles, function(role) {
                return role.Code + role.Description;
            });
        }
        else {
            var roleCodeMatchPartition = _.partition(roles, function(role) {
                return (role.Code).toLowerCase().indexOf(query.replace(' ', '').toLowerCase()) >= 0;
            });
            var roleCodeMatchStartPartition = _.partition(roleCodeMatchPartition[0], function(role) {
                return (role.Code).toLowerCase().indexOf(query.replace(' ', '').toLowerCase()) === 0;
            });

            var roleCodeStartMatches = _.sortBy(roleCodeMatchStartPartition[0], function(role) {
                return role.Code;
            });
            var roleCodeOtherMatches = _.sortBy(roleCodeMatchStartPartition[1], function(role) {
                return role.Code;
            });

            var otherMatches = _.sortBy(roleCodeMatchPartition[1], 'Description');

            var descriptionStartMatchPartition = _.partition(otherMatches, function(role) {
                return role.Description && role.Description.toLowerCase().indexOf(query.toLowerCase()) === 0;
            });

            var otherDescriptionMatches = _.filter(descriptionStartMatchPartition[1], function(role) {
                return role.Description && role.Description.toLowerCase().indexOf(query.toLowerCase()) > -1;
            });

            result = _.concat(roleCodeStartMatches, roleCodeOtherMatches, descriptionStartMatchPartition[0], otherDescriptionMatches);
        }

        return result;
    }
}

